/* tslint:disable */
var TComboBonusPresenter = (function () {    
    var buildView = {
        buildMultiOptions: function(betType)
        {
            if (ComboBonusProvider.ComboBonuses != null && !Modes.isCombinatorMode(BetSlip.CurrentMode)) {
                var comboBonus = ComboBonusProvider.ComboBonuses[betType];
                if (comboBonus) {
                    var onclickFunction = 'onclick="ComboBonusPresenter.openComboBonusMessage.betSlip('+betType+');"';
                    var percent = comboBonus.Percent || '';
                    return buildHTML(comboBonus.MessageType, percent, true, onclickFunction, 'isBtn', betType);
                }
            }

            return '';
        },

        buildPurchase: function(betType) {
            if (ComboBonusProvider.RecalculatedComboBonuses) {
                var comboBonus = ComboBonusProvider.RecalculatedComboBonuses[betType];
                if (comboBonus) {
                    var percent = comboBonus.Percent || '';
                    return buildHTML(comboBonus.MessageType, percent);
                }
            }

            return '';
        },
        //to-do:
        buildBetHistory: function(comboBonus) {
            if (comboBonus) {
                var percent = comboBonus.Percent || '';
                return buildHTML(comboBonus.MessageType, percent);
            }

            return '';
        },

        buildBetHistoryDetails: function(comboBonus) {
            if (comboBonus) {
                var params = <any>[];
                var percent = comboBonus.Percent || null;
                params.push(comboBonus.MessageType || 'null');
                params.push(comboBonus.Percent || 'null');
                params.push(comboBonus.MinPercent || 'null');
                params.push(comboBonus.MaxPercent || 'null');
                var paramsString = params.join(',');
                var onclickFunction = 'onclick="ComboBonusPresenter.openComboBonusMessage.betHistoryDetails('+paramsString+')"';
                buildHTML(comboBonus.MessageType, percent, false, onclickFunction, 'isBtn');
            }
        }             
    }

    function buildComboBonusMessage(betType) {
        if (ComboBonusProvider.ComboBonuses != null && !Modes.isCombinatorMode(BetSlip.CurrentMode)) {
            var comboBonus = ComboBonusProvider.ComboBonuses[betType];
            if (comboBonus) {
                return TComboBonusPresenter.buildComboBonusMessageHTML();
            }
        }

        return '';
    }
    
    function buildComboBonusMessageHTML() {
        return TComboBonusPresenter[BetSlipTemplateConroller.getComboBonusMessageTemplate(BetSlip.TemplateType)](); 
    }

    function buildRegularComboBonusMessageHTML() {
        return `
            <div class="msg">
                <div class="msg_box info_msg" onclick="ComboBonusPresenter.openComboBonusMessage.additionalMessageInPopup();">
                    ${ComboBonusPresenter.getAdditionalStaticMessage()}
                    <div class="icon i-18 i-o-betslip-info"></div>
                    <span class="info_btn">?</span>
                </div>
            </div>
        `;
    }

    function buildResponsiveComboBonusMessageHTML() {
        var isHiddenClass = ComboBonusPresenter.IsAdditionalMessageShown ? "isHidden" : "";
        return `
            <div id="combo-bonus-info-msg" class="msg ${isHiddenClass}">
                <div class="msg_box info_msg" data-action="ComboBonusPresenter.openComboBonusMessage.additionalMessage">
                    ${ComboBonusPresenter.getAdditionalStaticMessage()}
                    <div class="icon i-18 i-o-betslip-info"></div>
                    <span class="info_btn">?</span>
                </div>
            </div>
            ${buildAdditionalMessage()}
        `;
    }

    function buildAdditionalMessage() {
        var messageTitle = $dict.bs("ComboBonusAdditionalMessage") || $dict.ob("ComboBonusAdditionalMessage");
        var isHiddenClass = ComboBonusPresenter.IsAdditionalMessageShown ? "" : "isHidden";
        return `
            <div id="combo-bonus-additional-msg-container" class="msg--additional ${isHiddenClass}">
                <div class="msg_box info_msg">
                    <div class="msg-title">
                        ${messageTitle}
                    </div>
                    <div class="msg-text">
                        ${ComboBonusPresenter.getAdditionalMessage()}
                    </div>
                    <div class="msg-btn-holder">
                        ${ComboBonusPresenter.getAdditionalMessageInfoLink()}
                        <button id="combo-bonus-ok-btn" class="msg-btn" type="button" data-action="ComboBonusPresenter.openComboBonusMessage.additionalMessage">
                            ${$string("General").Ok}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }

    function buildHTML(msgType, percent, isBetSlipSelection?, onclickFunc?, isBtn?, betType?) {
       if(isBetSlipSelection) {
           return TComboBonusPresenter[BetSlipTemplateConroller.getComboBonusIconTemplate(BetSlip.TemplateType)](msgType, percent, onclickFunc, isBtn, betType);           
       } else {
           return TComboBonusPresenter.buildRegularComboBonusIcon(msgType, percent, onclickFunc, isBtn);
       }
    }
 
    function buildRegularComboBonusIcon(msgType, percent, onclickFunc, isBtn) {
        percent = percent || '';
        onclickFunc = onclickFunc || '';
        var classNames = <any>[];
        if (isBtn) {
            classNames.push('lnk_btn');
        }

        if (msgType >= 3) {
            classNames.push('isVariablePercent');
        }

        return `
            <div ${onclickFunc} class="combo_bonus_graphic ${classNames.join(' ')}">
                <div class="combo_bonus_content">
                    <div class="icon i-20 i-c-gift" data-uat="combo-bonus-icon"></div>
                    <div class="icon i-16 i-o-betslip-cb-coins"></div>
                    <div class="combo_bonus_percent_sign">&#37;</div>
                    <div class="combo_bonus_string" data-uat="combo-bonus-value">${percent}&#37;</div>
                </div>
            </div>
        `;
    }

    function buildResponsiveComboBonusIcon(msgType, percent, onclickFunc, isBtn, betType)
    {
        return ResponsiveHTMLTemplate.base.getTemplate('ComboBonusDrawer').buildComboBonusIconInBetSlip(msgType, percent, betType);
    }

    return {
        buildView: buildView,
        buildComboBonusMessage:buildComboBonusMessage, 
        buildComboBonusMessageHTML: buildComboBonusMessageHTML,
        buildRegularComboBonusMessageHTML: buildRegularComboBonusMessageHTML,
        buildResponsiveComboBonusMessageHTML: buildResponsiveComboBonusMessageHTML,
        buildRegularComboBonusIcon: buildRegularComboBonusIcon, 
        buildResponsiveComboBonusIcon: buildResponsiveComboBonusIcon
    };
}());

window.TComboBonusPresenter = TComboBonusPresenter;
jsRequire("/templates/Mobile/UniSlip/TComboBonusPresenter.ext.js");